import { Injectable } from '@angular/core';
import { timer } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClockService {

  private $time = timer(0, 1000).pipe(
    map(_ => {
      const now = new Date();
      now.setSeconds(0, 0);
      return now;
    }),
    distinctUntilChanged((a, b) => a.getTime() === b.getTime()),
    shareReplay({ refCount: true })
  );

  get time() {
    return this.$time;
  }
}
